<template>
    <flex-element
        :element-type="elementType"
        :tag="renderTag"
        class="f-flex"
        class-default-inline="f-relative f-flex-col f-w-1/1 f-items-start f-z-1 f-flex-wrap"
    >
        <drop-zone-output
            :elements-new="elementsNew"
            element-type="drop-zone-output"
            @element-updated="elementUpdated"
            @submit-form="submitForm"
        />

        <drop-zone-input
            v-if="isDroppable"
            :component-name="computedDisplayName"
            :elements-new="elementsNew"
            :text="text"
            :top-level="topLevel"
            :limit="limit"
            element-type="drop-zone-input"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Rendering } from '@/data/data-models';

export default {
    name: 'drop-zone-single',
    mixins: [baseOrganism],

    props: {
        componentName: {
            type: String,
            default: '',
        },

        displayName: {
            type: String,
            default: 'Container',
        },

        idOverride: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'div',
        },

        text: {
            type: String,
            default: '',
        },

        limit: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            elementsOriginalLength: 0,
            valueNew: '',
            tagNew: '',
            idOverrideNew: '',
        };
    },

    computed: {
        computedDisplayName() {
            return this.getElementData('displayName') || this.displayName;
        },

        isDroppable() {
            const isCarousel = this.$parent.$parent.$parent.$options._componentTag === 'carousel';

            return this.isComponentScreen || isCarousel;
        },

        listeners() {
            return this.$listeners;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },

        updatedElement() {
            const rendering = new Rendering({
                ...this.updatedBaseElement,
                renderingId: this.renderingId,
                renderingName: this.renderingName,
                dataSourceId: this.dataSourceId,
                elements: this.elementsNew,
                tag: this.tagNew,
                idOverride: this.idOverrideNew,
            });

            return rendering;
        },
    },

    watch: {
        idOverrideNew() {
            this.idOverride = this.idOverrideNew;
        },
    },

    beforeMount() {
        this.setFieldValues();
    },

    methods: {
        setFieldValues() {
            this.idOverrideNew = this.idOverride;
            this.tagNew = this.tag;

            if (this.elements) {
                this.elementsOriginalLength = this.elements.length;
            }
        },

        submitForm() {
            this.$emit('submit-form');
        },
    },
};
</script>
